export interface SubCategoriesDto
{
    getCategoryId() : number;
    getCategoryName() : string;
    getCdpCategoryId() : string;
    getCdpCategoryName() : string;
    getSubCdpCategoryId() : string;
}

export class SubCategoriesDtoImpl implements SubCategoriesDto 
{
    private categoryId: number;
    private categoryName: string;
    private cdpCategoryId: string;
    private cdpCategoryName: string;
    private subCdpCategoryId: string;

    getCategoryId(): number
    {
        return this.categoryId;
    }
    setCategoryId(categoryId: number)
    {
        this.categoryId = categoryId;
    }

    getCategoryName(): string
    {
        return this.categoryName;
    }
    setCategoryName(categoryName: string)
    {
        this.categoryName = categoryName;
    }

    getCdpCategoryId(): string
    {
        return this.cdpCategoryId;
    }
    setCdpCategoryId(cdpCategoryId: string)
    {
        this.cdpCategoryId = cdpCategoryId;
    }

    getCdpCategoryName(): string
    {
        return this.cdpCategoryName;
    }
    setCdpCategoryName(cdpCategoryName: string)
    {
        this.cdpCategoryName = cdpCategoryName;
    }

    getSubCdpCategoryId(): string
    {
        return this.subCdpCategoryId;
    }
    setSubCdpCategoryId(subCdpCategoryId: string)
    {
        this.subCdpCategoryId = subCdpCategoryId;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/categories/subcategorydto.ts